<template>
	<section class="stepsForm-include valigncenter w-100">
		<div class="row justify-content-center w-100">
			<form class="col-12" data-toggle="validator" method="post" enctype="multipart/form-data" id="individualForm" v-on:submit.prevent="submitIndividual()">
				<div class="row justify-content-center">
					<div class="col-12 col-lg-6 stepBorder text-center">
						<div v-for="(value, key, index) in documentsDescription" v-bind:key="index">
							<h3 class="text-center mb-3">{{ value.title }}</h3>
							<p class="smTrue mb-0">{{ value.description }}</p>
						</div>
	
						<div v-for="(value, key, index) in documentsByName" v-bind:key="index">
							<!-- image preview section -->
							<div class="d-flex loopUpload">
								<div class="attachmenttSatus" v-for="(val,ind) in value.data" v-bind:key="ind">
									<div v-if="val.name != ''">
										<vue-pdf v-if="val.name != '' && val.file.type == 'application/pdf'" :src="addfileImage(val.file)" />
										<img v-else-if="val.name != ''" :src="addfileImage(val.file)" style="height: 50px;" />
										<!-- <p>{{val.name}} size = {{parseInt(val.file.size / 1024)}} kB</p> -->
										<span class="deletedoc">
											<vue-feather type="x" @click="clearFileAddMore(key,ind)"></vue-feather>
										</span>
									</div>
								</div>
								<!-- show uploaded image -->
								<div class="attachmenttSatus" v-for="(val, index) in documentJsonData[key]" v-bind:key="index">
									<a class="" :href="static_vars.docsLink+'user&id='+get_user.profile.user_id+'&doc='+ val.name" target="_blank()">
										<vue-pdf height="50px" v-if="val.name.split('.')[val.name.split('.').length -1].toLowerCase() == 'pdf'" :src="static_vars.docsLink+'user&id='+get_user.profile.user_id+'&doc='+ val.name" />
										<img height="50px" v-else :src="static_vars.docsLink+'user&id='+get_user.profile.user_id+'&doc='+ val.name" />
									</a>
									<span class="deletedoc" :class="(pageLoader)?'disabled':''">
										<vue-feather type="trash-2"  v-on:click.stop.prevent="deleteFunc(key,val.id)"></vue-feather>
									</span>
								</div>
							</div>
							<!-- Doc Validation -->
							<div class="alert alert-danger d-flex align-items-center justify-content-between" role="alert" v-if="docValidation">
								{{$t("corporate_varify_step_three.please_upload_file")}}
								<vue-feather type="x" @click="docValidation = false"></vue-feather>
							</div>
							<!-- {{documentJsonData}} -->
							<div class="oneFive d-flex justify-content-end">
								<p class="mb-2">{{ index + 1 }} {{$t("corporate_varify_step_three.out_of_documents")}}</p>
							</div>
							<div class="loopUpload">
								<div class="uploadProof-row p-3 d-flex justify-content-between align-items-center">
									<div class="uploadText text-left">
										<h5>{{ value.description }}</h5>
									</div>
									<!-- add image input -->
									<div class="upload-btn-wrapper">
										<p class="btn d-flex align-items-center">
											<vue-feather type="upload" class="mr-2"></vue-feather> {{$t("corporate_varify_step_three.add_file")}}
										</p>
										<input type="file" name="document[]" :id="key" :ref="key" @change="addMoreFileChange($event.target.files[0], key)" />
									</div>
								</div>
								<p>
									{{$t("corporate_varify_step_three.max_file_size")}} {{ static_vars.fileSize.totalSize }} {{ static_vars.fileSize.type }}
								</p>
							</div>
							<div class="submitButton text-center my-4 mobRotate">
								<input type="button" class="backButton mr-2" value="Back" v-show="showTab > 0" @click.prevent.stop="showTab -= 1" />
								<input type="submit" class="btn btn-yellow" :class="pageLoader ? 'disabled' : ''" :value="showTab == Object.keys(documentsByName).length - 1 ? 'Submit' : 'Next'" name="" required="" />
							</div>
						</div>
					</div>
				</div>
			</form>
		</div>
	</section>
</template>

<script>
import { useMainStore } from "@/store";
export default {
	setup() {
		const store = useMainStore();
		return { store };
	},
	mounted() {},
	data() {
		return {
			pageLoader: false,
			submitted: false,
			lengthErrMsg: false,
			totalSizeErrMsg: false,
			individualSizeErrMsg: false,
			showTab: 0,
			documentJsonData: {},
			documentsDescription: {
				Letter_Of_Authorization: {
					title: "Letter Of Authorization",
					description: "Please upload Letter Of Authorization stating you have the authority to open an account on the organization’s behalf.",
				},
			},
			documentsByName: {
				Letter_Of_Authorization: {
					description: "Letter Of Authorization",
					data: [],
				},
			},
			docValidation: false,
		};
	},
	components: {},
	methods: {
		deleteFunc(getData1, docId){
			// console.log('del',getData1,docId);
			if(this.pageLoader){return;}
			let input_json={
				'globalParams' :{
					'id' : docId
				},
				'localParams' :{ "parameter" : this , 'getData' : getData1}
			}
			this._runDelDoc(input_json)
      },
		addfileImage(file){
			return URL.createObjectURL(file);
		},
		addMoreFileChange(file, docType) {
			this.docValidation = false;
			let length = this.documentsByName[docType].data.length;
			length +=
				this.documentJsonData[docType] != undefined ?
				this.documentJsonData[docType].length :
				0;
			if (length == 5) {
				this.lengthErrMsg = true;
			} else if (
				file.size / this.static_vars.fileSize.conversion >
				this.static_vars.fileSize.individualSize
			) {
				this.individualSizeErrMsg = true;
			} else {
				this.individualSizeErrMsg = false;
				this.lengthErrMsg = false;
				this.documentsByName[docType].data.push({
					file: file,
					name: file.name,
				});
			}
			document.getElementById(docType).value = "";
		},
		clearFileAddMore(docType,index){
			this.documentsByName[docType].data.splice(index, 1);
			this.lengthErrMsg = false
			this.totalSizeErrMsg = false
			this.individualSizeErrMsg = false
      },
		submitIndividual() {
			if (this.pageLoader) {
				return;
			}
			this.lengthErrMsg = false;
			const _that = this;
			_that.submitted = true;
			// let formRequest = document.getElementById('individualForm');
			let form_name = new FormData();
			let fileSize = 0;
			let docType = Object.keys(this.documentsByName)[this.showTab];
			let haveFiles = 0;
			let filelength = this.documentsByName[docType].data.length;
			filelength +=
				this.documentJsonData[docType] != undefined ?
				this.documentJsonData[docType].length :
				0;
			this.documentsByName[docType].data.forEach((item) => {
				if (item.name != "") {
					form_name.append(
						"document[]",
						item.file,
						docType +
						"." +
						item.name.split(".")[item.name.split(".").length - 1]
					);
					form_name.append("documenttype", docType);
					haveFiles += 1;
					fileSize += item.file.size;
				}
			});
			if (haveFiles > 0) {
				console.log("107", haveFiles);
				this.docValidation = false;
				if (
					fileSize / this.static_vars.fileSize.conversion >
					this.static_vars.fileSize.totalSize
				) {
					this.totalSizeErrMsg = true;
					_that.$notify({
						group: "foo",
						type: "error",
						text: "files size should be lesser then 60 MB",
						duration: 10000,
						closeOnClick: true,
					});
				} else {
					this.totalSizeErrMsg = false;
					this.individualSizeErrMsg = false;
					let input_json = {
						globalParams: {
							form: form_name,
						},
						localParams: { parameter: _that, type: "form" },
					};
					if (_that.showTab == Object.keys(_that.documentsByName).length - 1) {
						input_json.localParams.step = "4";
						form_name.append("step", "4");
					}
					// _that._runCorStep7(input_json)
					console.log("132", input_json);
				}
			}
			/*else if(this.showTab == Object.keys(_that.documentsByName).length-1){
				let input_json={
					'globalParams' :{
						'step' : '4'
					},
					'localParams' :{ "parameter" : _that, step : '4'}
				}
				// _that._runCorStep7(input_json)
        console.log("142", input_json)
			}*/
			else if (filelength == 0) {
				this.docValidation = true;
			} else {
				if (_that.showTab == 7) {
					_that.$router.replace("/dashboard");
				} else {
					this.showTab += 1;
				}
			}
		},
	},
};
</script>
